import React, { useState }  from 'react';
import { styled } from "styled-components";
import Button from "../button/button";
import arrowIcon from '../../assets/arrow_grey.svg';
import exampleImg from '../../assets/example.png';
import Popup from '../popup/popup';
import { t } from 'ttag';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  
  button {
    width: auto;
    margin-left: 10px;
  }
  
  @media (max-width: 768px) {
    button {
      margin-left: 10px;
    }
  }
`;

const Section = styled.section`
`;

const ShareFeedback = ({ onSubmit }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <Wrapper>
      <Section>
        <h2>{t`Share your Confidential Feedback`}</h2>
        <div className='row mt-2'>
          <div className='col-12'>

            {t`In order to submit your anonymous and confidential feedback form, EasyLlama requests that you provide a personal contact number. This contact information is not shared with your employer. Instead, you will be assigned a unique anonymous ID.`}<br />
            {t`Your employer will have the ability to anonymously message you to confirm they have received your form, and request further information if needed.`}

            <p className='mt-2'>
              {t`These messages will come from +18552621794 directly to your personal contact number.`}
            </p>
            <p className='mt-2'>
              {t`The contact information that you provide will be fully confidential, and never visible to your employer or the recipient of your feedback.`}
            </p>
            <p className='mt-2'>
              {t`You may review more about EasyLlama's Anonymous Reporting terms and conditions`} <a href="https://www.easyllama.com/terms-anonymous/" target="_blank">{t`here`}</a>.
            </p>

            <p className='mt-2'>
              <a href='#' onClick={() => {
                setShowPopup(true);
                return false;
              }}>
                {t`It's an example of what HR admin sees for the two-way communication.`}
                <img src={arrowIcon} alt='arrow' style={{marginLeft: '10px'}} />
              </a>
            </p>
          </div>
        </div>
        <div className='row mt-4'>
          <Button title={t`Provide a phone number`} onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
          }} />
        </div>
      </Section>
      {showPopup && (
          <Popup open={true} onClose={() => setShowPopup(false)} height='80vh' width='80vw'>
            <img src={exampleImg} alt='example' style={{width: '100%'}} />
          </Popup>
      )}
    </Wrapper>
  );
};

export default ShareFeedback;
